import React, { useEffect, useState } from 'react';

import { Button } from '@vimeo/bokeh';
import { CheckSmall, CloseXSmall, PlusSmall } from '@vimeo/bokeh-icons';
import { translate } from '@vimeo/i18n-runtime';

interface Props {
  disabled: boolean;
  isFollowing: boolean;
  onClick: () => void;
}

const FollowButton = ({ disabled, isFollowing, onClick }: Props) => {
  const [isHovering, setIsHovering] = useState<boolean>(false);
  const [buttonColor, setButtonColor] = useState<string>('blue.500');

  useEffect(() => {
    if (isFollowing && isHovering) {
      setButtonColor('status-destructive-primary');
    } else if (isFollowing) {
      setButtonColor('status-positive-primary');
    } else {
      setButtonColor('blue.500');
    }
  }, [isFollowing, isHovering]);

  return (
    <Button
      isDisabled={disabled}
      size="sm"
      onClick={onClick}
      variant="tertiary"
      sx={{
        color: buttonColor,
        borderColor: buttonColor,
      }}
      onMouseEnter={() => setIsHovering(true)}
      onFocus={() => setIsHovering(true)}
      onMouseLeave={() => setIsHovering(false)}
      onBlur={() => setIsHovering(false)}
      leftIcon={
        isFollowing && isHovering ? <CloseXSmall /> : isFollowing ? <CheckSmall /> : <PlusSmall />
      }
    >
      {isFollowing && isHovering
        ? translate('Unfollow')
        : isFollowing
          ? translate('Following')
          : translate('Follow')}
    </Button>
  );
};

export default FollowButton;
